const SupportIcon = (props: any) => {
  return (
    <svg height="20" width="20" fill="none" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M15.8334 14.1666H15.0001C14.5401 14.1666 14.1667 13.7933 14.1667 13.3333V9.16659C14.1667 8.70659 14.5401 8.33325 15.0001 8.33325H15.8334C16.7542 8.33325 17.5001 9.07909 17.5001 9.99992V12.4999C17.5001 13.4208 16.7542 14.1666 15.8334 14.1666Z"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M5 14.1666H4.16667C3.24583 14.1666 2.5 13.4208 2.5 12.4999V9.99992C2.5 9.07909 3.24583 8.33325 4.16667 8.33325H5C5.46 8.33325 5.83333 8.70659 5.83333 9.16659V13.3333C5.83333 13.7933 5.46 14.1666 5 14.1666Z"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M15.4166 8.33333V7.91667C15.4166 4.925 12.9916 2.5 9.99992 2.5V2.5C7.00825 2.5 4.58325 4.925 4.58325 7.91667V8.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M10.5208 17.7083H9.47917C8.90417 17.7083 8.4375 17.2417 8.4375 16.6667V16.6667C8.4375 16.0917 8.90417 15.625 9.47917 15.625H10.5208C11.0958 15.625 11.5625 16.0917 11.5625 16.6667V16.6667C11.5625 17.2417 11.0958 17.7083 10.5208 17.7083Z"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M11.5625 16.6667H13.3333C14.2542 16.6667 15 15.9209 15 15.0001V14.1667"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </svg>
  );
};

export default SupportIcon;
